(($, Drupal) => {
  function openSearchModal() {
    $("body").addClass("is-search-modal");
  }

  function closeSearchModal() {
    $("body").removeClass("is-search-modal");
  }

  Drupal.behaviors.searchModal = {
    attach: (context) => {
      const $searchModalOverlay = $(".js-search-modal-overlay", context);
      const $searchModal = $(".js-search-modal", context);
      const $serachModalBtn = $searchModal.find(".js-form-submit");
      const $searchModalClose = $(".js-search-modal-close", context);
      const $searchIcon = $(".js-search-icon", context);

      $searchIcon.on("click", openSearchModal);
      $searchModalClose.on("click", closeSearchModal);
      $searchModalOverlay.on("click", closeSearchModal);
      $serachModalBtn.on("click", closeSearchModal);
    },
  };
})(jQuery, Drupal);
